import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggerService } from '../shared/logger/logger.service';
import { CookieService } from 'ngx-cookie-service';

export const cookieInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  // logger.debug('cookieInterceptor...');
  // const cookieService = inject(CookieService);
  const cookieReq = req.clone({
    withCredentials: true
  });
  logger.debug('cookieInterceptor...', cookieReq);
  return next(cookieReq);
};
